import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './TableActions.css';

const TableActions = ({ name, id }) => {
    console.log({name, id });
    const { t } = useTranslation();

    return (
        <ButtonGroup>
            {/*}<Button tag={Link} to={`/${name}/show/${id}`} outline color="primary" title={t(`${name}.show`)} >
                <i className="fa fa-eye"></i>
            </Button>{*/}
            <Button tag={Link} to={`/${name}/edit/${id}`} outline color="info" title={t(`${name}.edit`)} >
                <i className="fa fa-edit"></i>
            </Button>
            <Button tag={Link} to={`/${name}/delete/${id}`} outline color="danger" title={t('common.delete')} >
                <i className="fa fa-trash"></i>
            </Button>
        </ButtonGroup>
    );
}

export default TableActions;
